<template>
    <div class="flex flex-row text-gray-700 text-center h-5 text-xs">
        <button :disabled="counter <= options.min"
          class="btn btn-primary w-10 border" :class="disabledClass(counter <= options.min)"
          @click="Decrement"
        >
            -
        </button>
        <span class="w-10 border bg-white text-center"
        >
            {{ counter }}
        </span>
        <button class="btn btn-primary w-10 border"
          :class="disabledClass(options.max ? counter >= options.max : false)"
          @click="Increment"
          :disabled="options.max ? counter >= options.max : false"
        >
            +
        </button>
    </div>
</template>

<script>
export default {
  props: ['value', 'appOptions'],

  data() {
    return {
      counter: this.value,
      defaults: {
        standard: 1,
        step: 1,
        min: 1,
        max: null,
      },
    };
  },

  computed: {
    options() {
      return {
        ...this.defaults,
        ...this.appOptions,
      };
    },
  },

  watch: {
    value() {
      this.counter = this.value;
    },
  },

  methods: {

    Increment() {
      this.counter += this.options.step;
      this.$emit('input', this.counter);
    },
    Decrement() {
      this.counter -= this.options.step;
      this.$emit('input', this.counter);
    },

    disabledClass(isDisabled) {
      if (isDisabled) {
        return 'bg-gray-400 cursor-default';
      }
      return 'hover:text-white hover:bg-b2c-red-300';
    },
  },
};
</script>
